import { useEffect } from 'react';
import ChipSelectGroup from '@/app/common/components/ChipSelect/index.tsx';
import type { ChipOption } from '@/app/common/components/ChipSelect/types.ts';
import type { FilterComponentProps } from '@/app/common/filters/core/filterComponentType.ts';
import {
  applyDefaultValueWhenNoSelected,
  multiSelectDataOf,
  toggleValues,
} from '@/app/common/filters/core/filterOptionSelection.ts';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import LabelNode from '@/app/common/filters/types/shared/LabelNode.tsx';

export const FilterMultiSelectChips = ({
  filter,
  isLoading,
  maxVisibleOptions,
  handleFilterChanged,
}: FilterComponentProps) => {
  const { t } = useTranslation();
  const filterData = multiSelectDataOf(filter);
  const { disabled } = filter;

  useEffect(() => {
    applyDefaultValueWhenNoSelected(filter, handleFilterChanged);
  }, [filter, handleFilterChanged]);

  const options: ChipOption[] = filterData.options.map((option) => ({
    id: option.value,
    label: <LabelNode option={option} isDisabled={!!(option.disabled || disabled || isLoading)} showCounter={false} />,
    selected: option.selected,
    disabled: option.disabled,
  }));

  return (
    <ChipSelectGroup
      title={filterData.label}
      options={options}
      onToggle={(value) => handleFilterChanged([toggleValues(filter, [value])])}
      disabled={disabled}
      busy={isLoading}
      maxVisible={maxVisibleOptions}
      showMoreLabel={(hiddenCount) => t('vacation.oss.cards.view_more_number', { number: String(hiddenCount) })}
      showLessLabel={t('vacation.oss.flights_details.show_less')}
    />
  );
};
